@let r = rating();
<img [src]="r.path" [alt]="r.alt" />
